import React from 'react';


const BooksToBring = () => {
  return (
    <div className="containerStyle fade-in">
      <div>
      <h1 className='headingStyle'>Choosing a Piano Method Book</h1>
      <hr style={{color: 'black', fontSize: "5px"}}></hr>
      <p>
        When embarking on a piano learning journey, selecting the right method
        book is crucial. Several reputable brands cater to students of all ages
        and skill levels. Here, we'll explore some popular brands like <em>Bastien</em>,
        <em> Alfred</em>, and <a target='_blank' href='https://pianoadventures.com'><em>Faber and Faber</em></a>, as well as other supplementary materials to
        enhance your piano learning experience.
      </p>

      <h2 className="subheadingStyle">Method Books for Beginners:</h2>
      <ul>
        <li className='listItemStyle'> 
          ⭐️⭐️⭐️⭐️⭐️ <b><em>Faber and Faber's Piano Adventures:</em></b> This series has
          different levels, starting with "My First Piano Adventure" for young
          children (under 6) and "Piano Adventures" for older beginners. The
          books are engaging and emphasize musicality.
          <span style={{color: 'green'}}><b> Recommended</b></span>
        </li>
        <p className='paragraphStyle m-3'>Make sure that the book you order is marked "Lesson". This will be your primary book.</p>
        <div className='flex'>
          <div className='p-3' style={{display: 'inline-block'}}>
            <a href="https://pianoadventures.com/product/my-first-piano-adventure-lesson-book-a/" target='_blank'>
              <p><b>My First Piano Adventure</b></p>
            <img style={{width: '300px', display: 'inline-block'}} src='https://pianoadventures.com/wp-content/uploads/sites/13/2021/03/HomePage-MFPA-1.png'></img>
            <p>THE YOUNG BEGINNER, <span style={{color: 'red'}}>AGES 5-6</span></p>
            </a>
          </div>
          <div className='p-3' style={{display: 'inline-block'}}>
            <a href="https://pianoadventures.com/product/piano-adventures-primer-level-lesson-book-2nd-edition/" target='_blank'><p><b>Piano Adventures</b></p>
            <img style={{width: '300px', display: 'inline-block'}} src='https://pianoadventures.com/wp-content/uploads/sites/13/2021/03/HomePage-Basic-1.png'></img>
            <p>THE BASIC PIANO METHOD, <span style={{color: 'red'}}>AGES 6-11</span></p></a>
          </div>
          <div className='p-3' style={{display: 'inline-block'}}>
            <a href="https://pianoadventures.com/product/accelerated-piano-adventures-lesson-book-1/" target='_blank'><p><b>Accelerated Piano Adventures</b></p>
            <img style={{width: '300px', display: 'inline-block'}} src='https://pianoadventures.com/wp-content/uploads/sites/13/2021/03/HomePage-Accel-01.png'></img>
            <p>THE OLDER BEGINNER, <span style={{color: 'red'}}>AGES 12-17</span></p></a>
          </div>
          <div className='p-3' style={{display: 'inline-block'}}>
            <a href="https://pianoadventures.com/product/adult-piano-adventures-all-in-one-course-book-1/" target='_blank'><p><b>Adult Piano Adventures</b></p>
            <img style={{width: '300px', display: 'inline-block'}} src='https://pianoadventures.com/wp-content/uploads/sites/13/2021/03/HomePage-Adult-01.png'></img>
            <p>THE YOUNG AT HEART, <span style={{color: 'red'}}>AGES 18-98</span></p></a>
          </div>
        </div>
        <li className='listItemStyle'>
          <b><em>Bastien Piano Basics:</em></b> Known for its clear, progressive
            approach, Bastien offers a series suitable for children and adults
            alike. Beginners can start with "Piano for the Young Beginner" and
            progress through the series as they improve.
        </li>
        <div className='flex'>
          <div className='p-3' style={{display: 'inline-block'}}>
              <a href="https://kjos.com/bastien-piano-for-adults-book-1-book-2-cd.html" target='_blank'><p><b>Bastien Piano for Adults</b></p>
              <img style={{height: '150px', display: 'inline-block'}} src='https://kjos.com/pub/media/catalog/product/cache/87a5ce0e90985ed74fdadeec0e00bcda/k/p/kp1_1.jpg'></img>
              <p>Book 1 </p></a>
            </div>
        </div>
        <li className='listItemStyle'>
          <b><em>Alfred's Basic Piano Library:</em></b> Alfred's series is
            well-regarded for its comprehensive instruction and broad range of
            options. "Alfred's Basic Adult Piano Course" and "Alfred's Premier
            Piano Course" are suitable for adults and older beginners.
          </li>
      </ul>

      <h2 className="subheadingStyle">Understanding Levels:</h2>
      <p className='paragraphStyle'>
        Method books are often divided into levels to accommodate varying skill
        levels and age groups. As students progress, they move from one level to
        the next, each level introducing new concepts and challenges. It's
        essential to choose a level that matches the student's current
        proficiency to ensure steady progress.
      </p>
      <hr style={{color: 'black', fontSize: "5px"}}></hr>
      <h2 className="subheadingStyle">Supplementary Materials:</h2>
      <p>
        In addition to method books, there are various supplementary materials
        that can enhance a student's learning experience:
      </p>
      <ul>
        <li className='listItemStyle'>
          <em>Sight Reading Books:</em> These books focus on improving
          sight-reading skills, a crucial aspect of becoming a proficient
          pianist. Brands like "Sight Reading and Rhythm Every Day" by Helen
          Marlais and "A Line A Day Sight Reading" by Jane Smisor Bastien are excellent choices.
        </li>
        <li className='listItemStyle'>
          <em>Note Speller Books:</em> To reinforce note-reading skills, books
          like "John W. Schaum Note Spellers" offer drills and exercises.
        </li>
        <li className='listItemStyle'>
          <em>Improvisation Books:</em> Ann Collins' book "<a href="https://www.alfred.com/jazz-works/p/00-18785/" target="_blank">Jazz Works 
Beginning Jazz Techniques for Intermediate- to Advanced-Level Pianists</a>" is an excellent resource for those looking to enhance their improvisational skills. It covers various musical styles and provides practical exercises to develop your improvisation abilities.
        </li>
        <li className='listItemStyle'>
          <em>Technique Books:</em> Strengthening finger dexterity and hand
          coordination is vital. "<a href="https://www.pianogratis.com/partiturasgratis/hanon.pdf" target="_blank">Hanon: The Virtuoso Pianist in Sixty
          Exercises</a>" is a classic choice.
        </li>
        <li className='listItemStyle'>
          <em>Repertoire Books:</em> Exploring different musical styles and
          pieces is essential for developing musicality. Books like "The Classical Piano Anthology" offer a diverse selection.
        </li>
      </ul>
      <hr style={{color: 'black', fontSize: "5px"}}></hr>
      <h2 className="subheadingStyle">Working with What You Have:</h2>
      <p className='paragraphStyle'>
        If a student already has a method book, it's advisable to consult with
        a piano teacher or music instructor. They can assess the book's
        suitability and determine if it aligns with the student's current skill
        level and goals. Adjustments can be made to accommodate the student's
        needs.
      </p>

      <p className='paragraphStyle'>
        In conclusion, the choice of a piano method book should align with the
        student's age, skill level, and goals. Method books from trusted brands
        like Bastien, Alfred, and Faber and Faber offer comprehensive
        instruction, and supplementary materials help students hone specific
        skills. Consultation with a teacher can ensure the best fit for a
        student's musical journey.
      </p>
    </div>


    </div>
  );
}

export default BooksToBring;
